import { postRequest } from './_tools';

export function getWritingList(data) {
    return postRequest('appServer/api/user/getWritingList', data);
}

//获取vip倒计时
export function getVipCountdown(data) {
    return postRequest('appServer/api/user/getVipCountdown', data);
}

export function getWritingDetail(data) {
    return postRequest('appServer/api/user/getWritingDetail', data);
}

export function updateUserWriting(data) {
    return postRequest('appServer/api/user/updateUserWriting', data);
}

//获取口语对练评分报告
export function reportDetail(data) {
    return postRequest("appServer/service/ai/reportDetail", data);
}

//查询用户vip信息新
export function landingPage(params) {
    return postRequest("cif/vip/landingPage", params);
}

//免费领取会员
export function claimFreeTenDayVip(params) {
    return postRequest("cif/vip/claimFreeTenDayVip", params);
}

//获取开通记录
export function getVipRecord(params) {
    return postRequest("cif/vip/vipActivatePageList", params);
}

//创建订单
export function createOrder(params) {
    return postRequest("cif/vip/createOrder", params);
}

//创建订单
export function createOrderV2(params) {
    return postRequest("cif/vip/createOrderV2", params);
}

//查询订单状态
export function queryOrderStatus(params) {
    return postRequest("tradecore/order/load ", params);
}

// 兑换码兑换
export function redeemCode(params) {
    return postRequest("cif/voucher/redeem", params);
}

export function orderConfirm(params) {
    return postRequest("cif/vip/orderConfirm", params);
}

export function userBenefit(params) {
    return postRequest("cif/vip/userBenefit", params);
}

// 我的订单
export function myOrders(params) {
    return postRequest("cif/vip/myOrders", params);
}